/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import Footer from 'components/footer/Footer';
import Dashboard from 'components/dashboards/default';
import EmailDetail from 'components/app/email/email-detail/EmailDetail';
import Compose from 'components/app/email/compose/Compose';
import { v4 as uuidv4 } from 'uuid';
import CustomModal from './LayoutModal';
import AppProvider from 'context/AppContext';
import CallLayout from './CallLayouts/CallLayout';
import { Image } from 'react-bootstrap';
import homepageIcon from '../../assets/img/icons/homepage.png';
import commIcon from '../../assets/img/icons/communication.png';
import referencesIcon from '../../assets/img/icons/references.png';
import enterpriseIcon from '../../assets/img/icons/enterpriseicon.png';
import puzzlePng from '../../assets/img/icons/puzzle.png';
import servicesPng from '../../assets/img/icons/services.png';
import References from 'components/references';
import Solutions from 'components/solutions';
import Services from 'components/services';
import Enterprise from 'components/enterprise';
import Contact from 'components/contact';
import Endpoint from 'components/endpoint/Calendar';
import Analytics from 'components/support';
import Siem from 'components/siem';
import Hotspot from 'components/hotspot';
import GrdBlog from 'components/grdblog';
import Waf from 'components/waf';
import EmailSecurity from 'components/email-security';
import Dlp from 'components/dlp';
import Ips from 'components/ips';
import Mfa from 'components/mfa';
import Firewall from 'components/firewall';
import CloudSolutions from 'components/cloud-solutions';
import Iso9001 from 'components/iso9001';
import Settings from 'components/pages/user/settings/Settings';
import Contacts from 'components/app/support-desk/contacts/Contacts';
import { useAuth } from 'context/AuthWizardContext';
import Error404 from 'components/errors/Error404';
import AdminPanel from 'components/admin-panel/AdminPanel';
import ChangePassword from 'components/pages/user/settings/ChangePassword';
const CallPath = () => {
  const location = useLocation();
  const { pathname } = useLocation();
  const { user } = useAuth();
  console.log(user)
  const { id } = useParams(); // Dinamik ID'yi alır
  const routeEvent =  pathname;
  const isKanban = pathname.includes('kanban');
  const [dynamicDivs, setDynamicDivs] = useState([]); // Dinamik div'leri saklamak için bir dizi kullanın
  const [dynamicButtonDivs, setDynamicButtonDivs] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [selectedLayout, setSelectedLayout] = useState('T1');
  const [renderMethod, setRenderMethod] = useState(false);
  const [contextMenuPos, setContextMenuPos] = React.useState(null);
  const moveElement = useRef(null);
  const catchMouseEvent = useRef(null);
  const sourceIdRef = useRef(null);
  const sourceParent = useRef(null);
  const myUuid = uuidv4();
  const catchMouseLoc = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [tabList , setTabList] = useState([]);
  useEffect(() => {
    HideAllContentDivs();
    createDynamicDiv();
    
  }, [routeEvent]);
  useEffect(() => {}, [renderMethod]);


  document.addEventListener('DOMContentLoaded', () => {
    document.body.style.cursor = 'default';
  });  
  const handleDataChange = newData => {
    setSelectedLayout(newData);
  };
  const componentsMap = {
    '/': <Dashboard />,
    '/references': <References />,
    '/blog': <GrdBlog />,
    '/support/new-request': <CloudSolutions />,
    '/support': <Analytics />,
    '/siem': <Siem />,
    '/hotspot': <Hotspot />,
    '/waf': <Waf />,
    '/email-security': <EmailSecurity />,
    '/dlp': <Dlp />,
    '/ips': <Ips />,
    '/mfa': <Mfa />,
    '/support/open-request': <Firewall />,
    '/iso9001': <Iso9001 />,
    '/blog': <GrdBlog />,
    '/user/settings': <Settings />,
    '/authentication/split/Registration': <Outlet />,
    // Admin Panel sadece customerId === 96 ise gösterilecek, aksi halde Error404
    '/admin-panel': user.customerId === '96' ? <AdminPanel /> : <Error404 />,
    '/customer-management': user.customerId === '96' ? <Solutions /> : <Error404 />,
    '/user/settings/change-password': <ChangePassword/>
  };
  componentsMap[`/support/all-requests/${id}`] = <Enterprise />;
  const closeModal = () => {
    setModalShow(false);
  };
  const HandleClickTab = e => {
    // Her bir öğeye tıklama olayını ekleyin
    let targetId = e.target.id;
    let dataGroup = document.getElementById(targetId);
    if(dataGroup.getAttribute('dataGroup') === 'tab')
    {
      HideAllContentDivs(dataGroup.getAttribute('dataMoveUpId'));
      const sc0cDiv = document.getElementById(`C-${targetId}`);
      sc0cDiv.style.display = 'flex';
      const sc0bDiv = document.getElementById(targetId);
      sc0bDiv.style.background = 'rgb(250,250,250)';
    }
    
  };
  const showLastElement = (lastSCElement) => {
    
    let lastSCElementDiv = document.getElementById(lastSCElement);
    let childDivs = lastSCElementDiv.querySelectorAll('[dataIndex]');
    let tabElementAmount = getTabAmountSC(lastSCElement);


    if(tabElementAmount > 0 ){
      let maxDataIndex = -1;
      let maxDataIndexDivId = ''; // En yüksek değere sahip div'in id'sini saklamak için bir değişken
      childDivs.forEach(child => {
        let dataIndex = parseInt(child.getAttribute('dataIndex'));
        if (!isNaN(dataIndex) && dataIndex > maxDataIndex) {
          maxDataIndex = dataIndex;
          maxDataIndexDivId = child.id;
        }
      });
  
      const sc0cDiv = document.getElementById(`C-${maxDataIndexDivId}`);
      sc0cDiv.style.display = 'flex';
      const sc0bDiv = document.getElementById(maxDataIndexDivId);
      sc0bDiv.style.background = 'rgb(250,250,250)';
      
    }
    

  };
  const getTabAmountSC = (scId) => {
    let SCElement = document.getElementById(scId);
    let dataGroup = SCElement.querySelectorAll(`div[dataGroup="tab"]`);
    return dataGroup.length;

  }
  const getCountMainFromSTG = (stgId) => {
    let stgElement = document.getElementById(stgId);
    let dataGroupMain = stgElement.querySelectorAll(`div[dataGroup="main"]`)
    let dataGroupMainAmount = dataGroupMain.length;
    
    return dataGroupMainAmount;
  }
  const destroySCDiv = (sourceParent) => {
    let targetId = sourceParent;
    let getSCDiv = document.getElementById(targetId);
    let SCHeader = document.getElementById(`${targetId}-B`)
    let SCContent = document.getElementById(`${targetId}-C`)
    while (SCHeader.firstChild) {
      SCHeader.removeChild(SCHeader.firstChild);
    }
    while (SCContent.firstChild) {
      SCContent.removeChild(SCContent.firstChild);
    }
    let stgId = getSCDiv.getAttribute('stgId');
    let dataGroupMainAmount = getCountMainFromSTG(stgId);
    if(dataGroupMainAmount > 1){
      getSCDiv.remove();
    }
  }
  const HideAllContentDivs = async (dataMoveUpId) => {
    let contentId;
    let buttonId;
    if (dataMoveUpId) {
      contentId = `${dataMoveUpId}-C`;
      buttonId = `${dataMoveUpId}-B`;
    } 
    else {
      contentId = 'SC00-C';
      buttonId = 'SC00-B';
    }
    
    const sc0cDiv = document.getElementById(contentId);
    const sc0cDivElements = sc0cDiv.children;
    const sc0bDiv = document.getElementById(buttonId);
    const sc0bDivElements = sc0bDiv.children;
    
    if(sc0bDiv.childElementCount > 0){
      for (let i = 0; i < sc0cDivElements.length; i++) {
        const element = sc0cDivElements[i];
        element.style.display = 'none'; // Elementi gizle
      }
      for (let i = 0; i < sc0bDivElements.length; i++) {
        const element = sc0bDivElements[i];
        element.style.backgroundColor = 'lightGray'; // Elementi gizle
      }
    }
   
  };
  const getNewSCId = () => {
    let STElement = document.getElementById('ST1')
    let dataGroupMainElements = STElement.querySelectorAll(`div[dataGroup="main"]`);
    let maxSCId = 0;
    let rString;
    dataGroupMainElements.forEach(child => {
      const match = child.id.match(/\d+/);
      const eskiSayi = parseInt(match[0])
      if(eskiSayi < 50){
        if(maxSCId < eskiSayi){
          maxSCId = eskiSayi;
        }
      }
    })
    maxSCId += 1;
    if (maxSCId < 10) {
      rString = `SC0${maxSCId}`;
    } else {
      rString = `SC${maxSCId}`;
    }
    return rString;
  }
  const createSCElement = (lastSCElement, contentUuid) => {

    let newSCId = getNewSCId();


    const lastElement = document.getElementById(lastSCElement);

    const ParentElementId = lastElement.parentElement.id;
    const ParentElement = document.getElementById(ParentElementId);
    
    
    const newSCElement = document.createElement('div');
    newSCElement.id = newSCId;
    newSCElement.setAttribute("dataMoveUpId", `${newSCId}`)
    newSCElement.setAttribute("stgId", `${ParentElementId}`);
    newSCElement.setAttribute("dataGroup", 'main')
    newSCElement.style.height = '100%';
    newSCElement.style.display = 'flex';
    newSCElement.style.flexDirection = 'column';
    newSCElement.style.flex = 1;
    newSCElement.style.borderRadius = '10px';
    newSCElement.style.boxShadow = '0 0px 4px rgba(0, 0, 0, 0.1)'; // Add a box shadow
    newSCElement.addEventListener("mouseup", (e) => {
      handleOnMouseUp(e);
    });    
    const newSCBElement = document.createElement('div');
    newSCBElement.id = `${newSCId}-B`;
    newSCBElement.setAttribute("dataMoveUpId", `${newSCId}`)
    newSCBElement.setAttribute("stgId", `${ParentElementId}`);
    newSCBElement.setAttribute("dataGroup", 'header');
    newSCBElement.style.width = '100%';
    newSCBElement.style.flex = 0.4;
    newSCBElement.style.display = 'flex';
    newSCBElement.style.flexDirection = 'row';
    newSCBElement.style.flexWrap = 'wrap';
    newSCBElement.addEventListener("mouseup", (e) => {
      handleOnMouseUp(e);
    });
    const newSCCElement = document.createElement('div');
    newSCCElement.id = `${newSCId}-C`;
    newSCCElement.setAttribute("dataMoveUpId", `${newSCId}`);
    newSCCElement.setAttribute("stgId", `${ParentElementId}`);
    newSCCElement.setAttribute("dataGroup", 'contentWrapper');
    newSCCElement.style.width = '100%';
    newSCCElement.style.flex = 5;
    newSCCElement.style.display = 'grid';
    newSCCElement.style.overflow = 'none';
    newSCCElement.style.overflow = 'hidden';
    newSCCElement.addEventListener("mouseup", (e) => {
      handleOnMouseUp(e);
    });
    ParentElement.append(newSCElement);
    
    newSCElement.appendChild(newSCBElement);
    newSCElement.appendChild(newSCCElement);
   
    moveSCElement(contentUuid, newSCId);
    setRenderMethod(!renderMethod);
  };
  const moveSCElement = (contentUuid, parentElement) => {

    const ButtonElement = document.getElementById(contentUuid);
    const DivElement = document.getElementById(`C-${contentUuid}`);
    const forParentButton = document.getElementById(`${parentElement}-B`);
    const forParentDiv = document.getElementById(`${parentElement}-C`);
    forParentButton.appendChild(ButtonElement);
    forParentDiv.appendChild(DivElement);
    ButtonElement.setAttribute("dataMoveUpId", parentElement);
    DivElement.setAttribute("dataMoveUpId", parentElement);

    showLastElement(parentElement);
  };
  const closeSelectedTab = (contentUuid, srcParent) => {
    let srcParentButtons = `${srcParent}-B`;
    let hasChildSrcParent = document.getElementById(srcParentButtons);
    let selectedTabContent = document.getElementById(`C-${contentUuid}`);
    let selectedTabButton = document.getElementById(contentUuid);
    let mainSCDiv = document.getElementById(srcParent);
    if (hasChildSrcParent.childElementCount > 1) {
      selectedTabButton.remove();
      selectedTabContent.remove();
      showLastElement(srcParent);
    } else if (hasChildSrcParent.childElementCount == 1) {
      if (srcParent === 'SC00') {
        alert('Varsayilan Sekmeyi Kapatamazsiniz');
      } else {
        selectedTabButton.remove();
        selectedTabContent.remove();
        mainSCDiv.remove();
      }
    }
  };
  function ContextMenu({ x, y, onSelect }) {
    return (
      <div
        style={{
          position: 'fixed',
          top: y + 'px',
          left: x + 'px',
          backgroundColor: 'white',
          border: '1px solid #ddd',
          zIndex: 9999
        }}
      >
        <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
          <li
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onClick={() => onSelect('splitRight')}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseOut={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            Split Right
          </li>
          {/* <li
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onClick={() => onSelect('splitRight')}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseOut={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            Split Left
          </li>
          <li
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onClick={() => onSelect('splitRight')}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseOut={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            Split Up
          </li>
          <li
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onClick={() => onSelect('splitRight')}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseOut={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            Split Down
          </li> */}
          <li
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onClick={() => onSelect('closeSelectedTab')}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseOut={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            Close Tab
          </li>
          {sourceParent.current !== 'SC00' && (
            <li
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onClick={() => onSelect('destroySCDiv')}
            onMouseOver={e =>
              (e.currentTarget.style.backgroundColor = '#f5f5f5')
            }
            onMouseOut={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            Close All Tabs
          </li>
          )}
        </ul>
      </div>
    );
  };
  const handleRightClickOnTab = e => {
    e.preventDefault();
    setContextMenuPos({ x: e.clientX, y: e.clientY });
    sourceIdRef.current = e.target.id;
    let element = document.getElementById(sourceIdRef.current);
    let scParentElementId = element.parentElement.parentElement.id;
    sourceParent.current = scParentElementId;
  };
  const closeContextMenu = () => {
    setContextMenuPos(null);
  };
  const handleContextMenuSelect = e => {
    let sourceId = sourceIdRef.current;
    if (e === 'splitRight') {
      splitRight(sourceId, sourceParent.current);
    } else if (e === 'closeSelectedTab') {
      closeSelectedTab(sourceId, sourceParent.current);
    } else if (e === 'destroySCDiv') {
      destroySCDiv(sourceParent.current);
    } else if (e === 'splitUp') {
      splitRight(sourceId, sourceParent.current);
    }
  };
  const addtoTabList = (tab) => {
    // Mevcut dizinin bir kopyasını oluşturun
    const listArray = [...tabList];

    // Yeni öğeyi kopyaya ekleyin
    listArray.push(tab);

    // setState işlevini kullanarak diziyi güncelleyin
    setTabList(listArray);
  };
 
  const createDynamicDiv = () => {
    if (!tabList.includes(routeEvent)) {
    
    let newDivId = `C-${myUuid}`;
    let headerUuid = `H-${myUuid}`;
    let newButtonDivId = myUuid;
    let dataIndex = 0; // Başlangıç değeri sıfır olarak ayarlandı
    console.log(pathname)
    let ParentSelectedElement = document.getElementById('SC00-B');
    let childDivs = ParentSelectedElement.querySelectorAll('[dataIndex]');

    childDivs.forEach(child => {
        let childDataIndex = parseInt(child.getAttribute('dataIndex'));
        if (!isNaN(childDataIndex) && childDataIndex >= dataIndex) {
            dataIndex = childDataIndex + 1;
        }
    });

    const componentToShow = componentsMap[routeEvent];
    console.log(componentToShow)
    const newDiv = (
        <div
            id={newDivId}
            key={routeEvent}
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid #ccc',
                borderTop: 'none',
                borderRadius: '0 0 10px 10px',
                boxShadow: '0 0px 4px rgba(0, 0, 0, 0.1)', // Add a box shadow
                margin: '0 5px 0px', // Add margin for spacing
                overflowY: 'auto',
                overflowX: 'hidden'
            }}
            stgId='STG1'
            dataMoveUpId='SC00'
            dataGroup='content'
        >
            {componentToShow}
        </div>
    );
    const newButtonDiv = (
        <div
            id={newButtonDivId}
            key={routeEvent}
            dataIndex={dataIndex}
            onMouseDown={handleOnMouseDown}
            onMouseMove={handleMouseOnMove}
            onContextMenu={e => handleRightClickOnTab(e)}
            onMouseUp={e => handleOnMouseUp(e)}
            stgId='STG1'
            routeName={routeEvent}
            style={{
                height: '4vh', // Sabit yükseklik
                backgroundColor: 'rgb(250, 250, 250)',
                border: '1px solid #ccc',
                borderBottom: 'none',
                borderRadius: '10px 10px 0 0',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                margin: '5px 5px 0',
                transition: 'background-color 0.3s, transform 0.3s',
                position: 'relative',
                cursor: 'pointer',
                overflow: 'hidden',

                // Hover durumu için stil
                ':hover': {
                    backgroundColor: 'rgb(240, 240, 240)',
                    transform: 'scale(1.02)',
                },
            }}
            dataMoveUpId='SC00'
            dataGroup='tab'
        >
            {formatTitle(routeEvent) === 'Default' ?
            <div style={{display: 'flex',flexDirection: 'row',pointerEvents: 'none', marginTop: 5}}>
              <div style={{flex: 0.2, height: '100%'}}>
                <Image src={homepageIcon} style={{height: 24, alignItems:'center', justifyContent:'center', pointerEvents: 'none', marginLeft: 5}}/>
              </div>
              <div  style={{flex: 1,height: '100%'}}>
                <h6
                  style={{
                    pointerEvents: 'none',                
                    marginTop: 5,
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  id={headerUuid}
                >
                  DASHBOARD
                </h6>
              </div>
             
            </div> 
            :   
            formatTitle(routeEvent) === 'CUSTOMER-MANAGEMENT' ? 
            <div style={{display: 'flex',flexDirection: 'row',pointerEvents: 'none', marginTop: 5}}>
              <div style={{flex: 0.2, height: '100%'}}>
                <Image src={puzzlePng} style={{height: 24, alignItems:'center', justifyContent:'center', pointerEvents: 'none', marginLeft: 5}}/>
              </div>
              <div  style={{flex: 1,height: '100%'}}>
                <h6
                  style={{
                    pointerEvents: 'none',                
                    marginTop: 5,
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem"
                  }}
                  id={headerUuid}
                >
                  MÜŞTERİ YÖNETİMİ
                </h6>
              </div>
             
            </div> 
            :
            formatTitle(routeEvent) === 'CHANGE-PASSWORD' ? 
            <div style={{display: 'flex',flexDirection: 'row',pointerEvents: 'none', marginTop: 5}}>
              <div style={{flex: 0.2, height: '100%'}}>
                <Image src={puzzlePng} style={{height: 24, alignItems:'center', justifyContent:'center', pointerEvents: 'none', marginLeft: 5}}/>
              </div>
              <div  style={{flex: 1,height: '100%'}}>
                <h6
                  style={{
                    pointerEvents: 'none',                
                    marginTop: 5,
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem"
                  }}
                  id={headerUuid}
                >
                  PAROLA DEĞİŞTİR
                </h6>
              </div>
             
            </div> 
            :
            formatTitle(routeEvent) === `${id}` ? 
            <div style={{display: 'flex',flexDirection: 'row',pointerEvents: 'none', marginTop: 5}}>
              <div style={{flex: 0.2, height: '100%'}}>
                <Image src={enterpriseIcon} style={{height: 24, alignItems:'center', justifyContent:'center', pointerEvents: 'none', marginLeft: 5}}/>
              </div>
              <div  style={{flex: 1,height: '100%'}}>
                <h6
                  style={{
                    pointerEvents: 'none',                
                    marginTop: 5,
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem"
                  }}
                  id={headerUuid}
                >
                  {user.customerName} 
                </h6>
              </div>
             
            </div> 
            :
            formatTitle(routeEvent) === `ADMIN-PANEL` ? 
            <div style={{display: 'flex',flexDirection: 'row',pointerEvents: 'none', marginTop: 5}}>
              <div style={{flex: 0.2, height: '100%'}}>
                <Image src={enterpriseIcon} style={{height: 24, alignItems:'center', justifyContent:'center', pointerEvents: 'none', marginLeft: 5}}/>
              </div>
              <div  style={{flex: 1,height: '100%'}}>
                <h6
                  style={{
                    pointerEvents: 'none',                
                    marginTop: 5,
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem"
                  }}
                  id={headerUuid}
                >
                  {user.customerId === '96' ? 'ADMIN PANEL' : 'ERROR'}
                </h6>
              </div>
             
            </div>
            :
            formatTitle(routeEvent) === `SETTINGS` ? 
            <div style={{display: 'flex',flexDirection: 'row',pointerEvents: 'none', marginTop: 5}}>
              <div style={{flex: 0.2, height: '100%'}}>
                <Image src={enterpriseIcon} style={{height: 24, alignItems:'center', justifyContent:'center', pointerEvents: 'none', marginLeft: 5}}/>
              </div>
              <div  style={{flex: 1,height: '100%'}}>
                <h6
                  style={{
                    pointerEvents: 'none',                
                    marginTop: 5,
                    marginLeft: "0.5rem",
                    marginRight: "0.5rem"
                  }}
                  id={headerUuid}
                >
                  PROFIL DUZENLE
                </h6>
              </div>
             
            </div>
            : null
            
          }
          
        </div>
    );
    
    // Dinamik div'leri güncelleyin
    setDynamicDivs([...dynamicDivs, newDiv]);
    setDynamicButtonDivs([...dynamicButtonDivs, newButtonDiv]);
    addtoTabList(routeEvent);
  } else {
    const elements = document.querySelectorAll("[routeName]");
      elements.forEach(element => {
        const routeNameValue = element.getAttribute("routeName");
      
        // İstediğiniz koşula göre elementi seçebilirsiniz
        if (routeNameValue === routeEvent) {
          console.log(element.id)
          const sc0cDiv = document.getElementById(`C-${element.id}`);
          sc0cDiv.style.display = 'flex';
          const sc0bDiv = document.getElementById(element.id);
          sc0bDiv.style.background = 'rgb(250,250,250)';

        }
      });

  }
};
  const handleOnMouseDown = async e => {
  
    if (e.button == 0 && e.buttons == 1) {
      let targetId = e.target.id;
      if (targetId.startsWith('H-')) {
        targetId = targetId.substring(2);
      }
      document.body.style.cursor = 'move';
      document.body.style.userSelect = 'none';
      let selectedElement = document.getElementById(targetId);
      let getParentSelectedElement = selectedElement.parentElement.id;
      sourceParent.current = selectedElement.parentElement.parentElement.id;
      let ParentSelectedElement = document.getElementById(
        getParentSelectedElement
      );
      let childDivs = ParentSelectedElement.querySelectorAll('[dataIndex]');
      let maxChildDataIndex = -1;
      childDivs.forEach(child => {
        let childDataIndex = parseInt(child.getAttribute('dataIndex'));
        if (!isNaN(childDataIndex) && childDataIndex > maxChildDataIndex) {
          maxChildDataIndex = childDataIndex;
        }
      });

      let updateSelectedDataIndex = maxChildDataIndex + 1;
      selectedElement.setAttribute('dataIndex', updateSelectedDataIndex);
      setRenderMethod(!renderMethod);

      moveElement.current = targetId; // Store the targetId in the ref
    }
  };
  const handleOnMouseUp = e => {
    if (e.button == 0 && e.buttons == 0 && e.target.id && moveElement.current) {
      document.body.style.userSelect = 'auto';
      let targetId = e.target.id;
      let targetElement = document.getElementById(targetId);
      let getDataGroup = targetElement.getAttribute('dataGroup');
      if(getDataGroup !== null){
      let nextDataIndex = 0;
      let elementDataMoveUpId = targetElement.getAttribute("dataMoveUpId");
      let elementStgId = targetElement.getAttribute("stgId");


      let targetTabElement = document.getElementById(`${elementDataMoveUpId}-B`);
      let targetContentElement = document.getElementById(`${elementDataMoveUpId}-C`)
      let sourceTabElement = document.getElementById(moveElement.current);
      let sourceContentElement = document.getElementById(`C-${moveElement.current}`)
      
      if(sourceTabElement.getAttribute('dataMoveUpId') === elementDataMoveUpId)
      {
        //Ayni SC icindeki bir tab tiklamasinda calisir.
        HandleClickTab(e)
        HideAllContentDivs(elementDataMoveUpId);
        showLastElement(elementDataMoveUpId);

        
      }else {
        
        //Bir tabi farkli bir SC ye tasima sonrasinda calisir.
        targetContentElement.append(sourceContentElement);
        targetTabElement.append(sourceTabElement);
        sourceTabElement.setAttribute("dataMoveUpId", `${elementDataMoveUpId}`)
        sourceTabElement.setAttribute("stgId", `${elementStgId}`);
        let targetTabs = targetTabElement.querySelectorAll('[dataIndex]');
        // Biraktigimiz yerdeki tablari tarayip en buyuk dataIndex degerini bulup tasinan taba n+1 index degerini set ediyoruz.
        targetTabs.forEach(child => {
          let dataIndex = parseInt(child.getAttribute('dataIndex'));
          if(dataIndex>nextDataIndex){
            nextDataIndex=dataIndex
          }
        })
      
        nextDataIndex += 1;
        sourceTabElement.setAttribute("dataIndex", nextDataIndex);
        HideAllContentDivs(elementDataMoveUpId);
        // Tasindigi tabtaki dataIndexi en buyuk tabi aciyoruz.
        showLastElement(elementDataMoveUpId);
        // Source Tab yakalanir ve en buyuk dataIndex tespit edilir.
        HideAllContentDivs(sourceParent.current);
        // Tasindigi tabtaki dataIndexi en buyuk tabi aciyoruz.
        showLastElement(sourceParent.current);
      }

      }
      
      

      
    }
    
  };
  const handleMouseOnMove = e => {
    // MouseMove sırasında her şeyi seçmeyi engellemek için
    e.preventDefault();
    catchMouseEvent.current = e.target.id;
    catchMouseLoc.current = {x: e.clientX, y: e.clientY};

    // İşlem yapmak istediğiniz diğer kodlar buraya gelebilir
  };
  const splitRight = (currentElementUUid, srcParent) => {
    
    let currentElement = document.getElementById(currentElementUUid);
    let currentElementStgId = currentElement.getAttribute("stgId");
    let currentElementDataMoveUpId = currentElement.getAttribute("dataMoveUpId");
    let headerCount = 5
    
    if (srcParent === 'SC00') {
      if (headerCount > 1) {
        

        createSCElement(currentElementDataMoveUpId, currentElementUUid);
        
      } else {
        alert(
          'Varsayilan Pencereyi Parcalayamazsiniz Yeni bir ekran acarak parcalamaya devam edebilirsiniz.'
        );
      }
    } else {
      createSCElement(currentElementDataMoveUpId, currentElementUUid);

    }
    if (headerCount >= 1) {
      showLastElement(srcParent);
    }
  };
  function formatTitle(param) {
    const reversedParam = param.split('').reverse().join('');
    const indexOfEqualSign = reversedParam.indexOf('=');
        
    if (indexOfEqualSign !== -1) {
      const title = reversedParam.substring(0, indexOfEqualSign);
      const formattedTitle = title.split('').reverse().join(''); // Diziyi tekrar orijinal sırasına çevirir
      return formattedTitle.charAt(0).toUpperCase() + formattedTitle.slice(1); // İlk harfi büyük yapar
    }
    const indexOfFirstSlash = reversedParam.indexOf('/');

    if (indexOfFirstSlash !== -1) {
      const title = reversedParam.substring(0, indexOfFirstSlash);
      
      const formattedTitle = title.split('').reverse().join(''); 
      if (formattedTitle === '') {
        return 'Default';
      }
      console.log(formattedTitle)
      return formattedTitle.toUpperCase(); // İlk harfi büyük yapar
    }

    // '=' veya '/' bulunamazsa, varsayılan başlık olarak 'Dashboard' döner ve ilk harfini büyük yapar
    return 'Dashboard';
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '85vh',
        width: 'auto',
        backgroundColor: 'transparent',
      }}
      onClick={closeContextMenu}
    >
      {/* <div className='setting-toggle card'  id="selectLayout" style={{ marginTop: '50px' }} onClick={openModal}>
        <div className='d-flex align-items-center py-md-2 px-2 py-1 card-body'>
          <div className='bg-soft-primary position-relative rounded-start'>
            <div className='settings-popover position-absolute top-0 start-50 translate-middle-x'>
              <span className='ripple'>
                <span className='fa-spin position-absolute all-0 d-flex flex-center'>
                  <span className='icon-spin position-absolute all-0 d-flex flex-center'>
                  
                  </span>
                </span>
              </span>
            </div>
            <small className='text-uppercase text-primary fw-bold bg-soft-primary py-2 pe-2 ps-1 rounded-end'>
             Select Layout
            </small>
          </div>
        </div>
      </div> */}
      <div
        style={{
          height: '90vh',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '8px' /* Add rounded corners */,
          display: 'flex',
          borderTopLeftRadius: '0',
          flexDirection: 'column',
          flex: 1,
          backgroundColor: 'transparent',

        }}
        id="MainDiv"
      >
        <div style={routeEvent  ? {display: 'flex',height: '100%',width: '100%',} : {display: 'none'}}>
          <CallLayout
              dynamicButtonDivs={dynamicButtonDivs}
              dynamicDivs={dynamicDivs}
              selectedLayout={selectedLayout}
              handleMouseUpFunction={handleOnMouseUp}
            />
        </div>
        <div style={{ width: '100%', height: '10%', display: 'flex', }}>
          {!isKanban && <Footer />}
        </div>
      </div>
      <AppProvider>
        <CustomModal
          onDataChange={handleDataChange}
          show={modalShow}
          onHide={closeModal}
          title="Select Your Layout"
        />
      </AppProvider>
      {contextMenuPos && (
        <ContextMenu
          x={contextMenuPos.x}
          y={contextMenuPos.y}
          onSelect={e => handleContextMenuSelect(e)}
        />
      )}
    </div>
  );
};

export default CallPath;